<template>
  <div class="limits">
    <template v-if="!listLoaded">
      <div class="limits__loader">
        <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
      </div>
    </template>
    <template v-else v-for="(asset, i) in Object.keys(accountBalances)">

      <div class="container-header">
        <div class="container-header__title">{{ assetName(asset) }} ({{ asset }})</div>
      </div>

      <md-card class="container container_40" :key="i">

        <md-table class="limits-table scrollbar">
          <md-table-row class="limits__row">
            <md-table-head>{{ i18n.lim_transaction_type_title() }}</md-table-head>
            <md-table-head><div>{{ i18n.lim_one_time() }}</div></md-table-head>
            <md-table-head><div>{{ i18n.lim_daily() }}</div> <div>{{ i18n.lim_left_total() }}</div></md-table-head>
            <md-table-head><div>{{ i18n.lim_weekly() }}</div> <div>{{ i18n.lim_left_total() }}</div></md-table-head>
            <md-table-head><div>{{ i18n.lim_monthly() }}</div> <div>{{ i18n.lim_left_total() }}</div></md-table-head>
            <md-table-head><div>{{ i18n.lim_annual() }}</div> <div>{{ i18n.lim_left_total() }}</div></md-table-head>
          </md-table-row>
          <template v-for="([operation, name],idx) in Object.entries(transactionTypes)">
            <md-table-row class="limits-table__row" :key="i">
              <md-table-cell class="text_large limits-table__type">{{ operation === transactionTypes.withdrawal ? i18n.tx_withdrawal() : i18n.tx_transfer() }}</md-table-cell>
              <md-table-cell class="text_medium">
                {{ getLimitValue (i, operation, 'operation') ? getLimitValue (i, operation, 'operation')['amount_limit'] : '-' }}
              </md-table-cell>
              <md-table-cell class="text_medium">
                {{ getLimitValue (i, operation, 'day') ? getLimitValue (i, operation, 'day')['amount'] : '-' }}
                /
                {{ getLimitValue (i, operation, 'day') ? getLimitValue (i, operation, 'day')['amount_limit'] : '-' }}
              </md-table-cell>
              <md-table-cell class="text_medium">
                {{ getLimitValue (i, operation, 'week') ? getLimitValue (i, operation, 'week')['amount'] : '-' }}
                /
                {{ getLimitValue (i, operation, 'week') ? getLimitValue (i, operation, 'week')['amount_limit'] : '-' }}
              </md-table-cell>
              <md-table-cell class="text_medium">
                {{ getLimitValue (i, operation, 'month') ? getLimitValue (i, operation, 'month')['amount'] : '-' }}
                /
                {{ getLimitValue (i, operation, 'month') ? getLimitValue (i, operation, 'month')['amount_limit'] : '-' }}
              </md-table-cell>
              <md-table-cell class="text_medium">
                {{ getLimitValue (i, operation, 'year') ? getLimitValue (i, operation, 'year')['amount'] : '-' }}
                /
                {{ getLimitValue (i, operation, 'year') ? getLimitValue (i, operation, 'year')['amount_limit'] : '-' }}
              </md-table-cell>
            </md-table-row>
          </template>
        </md-table>
        <!--<div class="btn-wrap margin-top">
          <md-button class="btn md-primary" @click="showForm(asset)">{{i18n.lim_change_limits()}}</md-button>
        </div>-->
      </md-card>
    </template>
   <!-- <div class="limits__requests-list"
         v-if="accountTypeI !== ACCOUNT_TYPES.notVerified">
      <limits-list :list="limitsRequests" />
    </div>
    <md-dialog :md-active.sync="showDialog">
      <limits-manager :limits="selectedLimits"
                       :asset="asset"
                       @close-request="showDialog = false"/>
    </md-dialog>-->
  </div>
</template>

<script>
  import FormMixin from '@com/mixins/form.mixin'
  import LimitsManager from './Limits.Manager'
  import LimitsList from './Limits.List'
  import Modal from '../common/Modal'

  import cloneDeep from 'lodash/cloneDeep'
  import omit from 'lodash/omit'
  import get from 'lodash/get'

  import { RecordFactory } from '@js/records/factory'
  import { vuexTypes } from '@vuex/types'
  import { i18n } from '@js/i18n'
  import { mapGetters, mapActions } from 'vuex'
  import { usersService } from '@api/users.service'
  import { transactionType, transactionTypeDescription } from '@js/const/limits.const'

  import {
    STATS_OPERATION_TYPES,
    ACCOUNT_TYPES,
    LIMIT_OPS_STR
  } from '@const'

  export default {
    name: 'LimitsIndex',
    mixins: [FormMixin],
    components: {
      LimitsManager,
      LimitsList,
      Modal },
    data: _ => ({
      showDialog: false,
      limitOp: '',
      asset: null,
      selectedLimits: null,
      allLimits: [],
      listLoaded: false,
      i18n,
      LIMIT_OPS_STR,
      ACCOUNT_TYPES,
      STATS_OPERATION_TYPES
    }),
    created () {
      this.checkLimits()
    },
    computed: {
      ...mapGetters([
        vuexTypes.accountBalances,
        vuexTypes.accountTypeI,
        vuexTypes.accountLimits,
        vuexTypes.limitsRequests,
        vuexTypes.accountId
      ]),
      limitOperations () {
        const limitsOperations = cloneDeep(LIMIT_OPS_STR)
        return (this.accountTypeI !== this.ACCOUNT_TYPES.notVerified) ? limitsOperations : omit(limitsOperations, 'withdrawal')
      },
      transactionTypes () {
        return transactionTypeDescription
      }
    },
    methods: {
      ...mapActions({
        loadLimits: vuexTypes.GET_ACCOUNT_LIMITS,
        loadRequests: vuexTypes.GET_LIMITS_REQUESTS
      }),
      async checkLimits () {
        for (const asset in this.accountBalances) {
          const transfer = await usersService.getLimit(this.accountBalances[asset].asset, transactionType.transfer)
          const withdrawal = await usersService.getLimit(
            this.accountBalances[asset].asset,
            transactionType.withdrawal,
            asset.includes('USDT') ? 'usdt' : ''
          )
          const result = {
            asset: asset,
            limits: {
              transfer,
              withdrawal
            }
          }
          this.allLimits.push(result)
        }
        this.listLoaded = true
      },
      getLimitValue (index, operation, term) {
        if (this.allLimits[index] && this.allLimits[index].limits && this.allLimits[index].limits[operation]) {
          return this.allLimits[index].limits[operation].find(el => el.period === term)
        }
        return null
      },
      showForm (asset) {
        this.asset = asset
        this.selectedLimits = this.limits(asset)
        this.showDialog = true
      },
      assetName (asset) {
        return get(this.accountBalances[asset], 'asset_details.details.name')
      },
      limits (tokenCode) {
        const limits = this.accountLimits
          .filter(limit => limit.tokenCode === tokenCode)
          .reduce((limits, limit) => {
            if (limit.statsOpType === STATS_OPERATION_TYPES.paymentOut) {
              return { ...limits,
                payment: limit
              }
            }
            if (limit.statsOpType === STATS_OPERATION_TYPES.withdraw) {
              return { ...limits,
                withdrawal: limit
              }
            }
            if (limit.statsOpType === STATS_OPERATION_TYPES.deposit) {
              return { ...limits,
                deposit: limit
              }
            }
            return limits
          }, {})
        if (!limits.payment) limits.payment = RecordFactory.createLimitRecord()
        if (!limits.withdrawal) limits.withdrawal = RecordFactory.createLimitRecord()
        if (!limits.deposit) limits.deposit = RecordFactory.createLimitRecord()
        return limits
      }
    }
  }
</script>

<style lang="scss">
  @import '~scss/variables';

  // md-card alternative
  .limits {

    &__loader {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    & .limits-table {
      background-color: transparent;

      &__type {
        font-weight: 600;
        text-transform: capitalize;
      }
    }
  }

  .limits__list {
    width: 50%;
  }
  .limits__op-name {
    margin-bottom: 1.6rem;
  }
  .limits__list-item {
    margin-bottom: .75rem;
  }
  .limits__list-item-label {
    display: inline-block;
    margin-right: 1rem;
    width: 8rem;
  }

  .limits__list-wrapper {
    display: flex;
  }

  .limits_select-field {
    width: 10rem
  }

  .limits__requests-list {
    margin-top: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/limits/Limits.Index.vue